import { BooleanDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { DateDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/DateDataDefinition";
import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { ObjectDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";

export const getTestInputDataDefinition = (): DataDefinition => {
    let data = new DataDefinition();
    data.fields.push(new StringDataDefinition("employeeID"));
    data.fields.push(new StringDataDefinition("firstName"));
    data.fields.push(new StringDataDefinition("lastName"));
    data.fields.push(new StringDataDefinition("socialSecurityNumber"));

    let obj = new ObjectDataDefinition("homeAddress");
    obj.fields.push(new StringDataDefinition("streetAddress"));
    obj.fields.push(new StringDataDefinition("city"));
    obj.fields.push(new StringDataDefinition("state"));
    obj.fields.push(new StringDataDefinition("zipCode"));
    obj.fields.push(new StringDataDefinition("country"));
    data.fields.push(obj);

    data.fields.push(new StringDataDefinition("emailAddress"));
    data.fields.push(new StringDataDefinition("phoneNumber"));
    data.fields.push(new DateDataDefinition("dateOfBirth"));
    data.fields.push(new DateDataDefinition("dateOfHire"));
    data.fields.push(new DateDataDefinition("dateOfTermination"));

    data.fields.push(new StringDataDefinition("position"));
    data.fields.push(new StringDataDefinition("salaryBand"));
    data.fields.push(new StringDataDefinition("department"));
    data.fields.push(new StringDataDefinition("managerID"));

    data.fields.push(new BooleanDataDefinition("fullTime"));
    data.fields.push(new StringDataDefinition("benefitsID"));
    data.fields.push(new BooleanDataDefinition("exempt"));

    obj = new ObjectDataDefinition("disciplinaryActionsHistory");
    obj.list = true;
    obj.fields.push(new StringDataDefinition("description"));
    obj.fields.push(new StringDataDefinition("currentManagerID"));
    obj.fields.push(new StringDataDefinition("actionTaken"));
    obj.fields.push(new DateDataDefinition("dateOfIncident"));
    data.fields.push(obj);

    data.fields.push(new NumberDataDefinition("vacationDaysUsed"));
    data.fields.push(new NumberDataDefinition("sickDaysUsed"));
    data.fields.push(new NumberDataDefinition("vacationDaysRemaining"));
    data.fields.push(new NumberDataDefinition("sickDaysRemaining"));

    data.fields.push(new StringDataDefinition("emergencyContactName"));
    data.fields.push(new StringDataDefinition("emergencyContactPhoneNumber"));
    data.fields.push(new StringDataDefinition("emergencyContactRelationship"));

    data.fields.push(new BooleanDataDefinition("onboarded"));

    obj = new ObjectDataDefinition("promotionHistory");
    obj.list = true;
    obj.fields.push(new StringDataDefinition("position"));
    obj.fields.push(new DateDataDefinition("dateOfPromotion"));
    obj.fields.push(new StringDataDefinition("comments"));
    obj.fields.push(new NumberDataDefinition("salary"));
    data.fields.push(obj);

    data.fields.push(new BooleanDataDefinition("isManager"));

    let field = new StringDataDefinition("directReportsID");
    field.list = true;
    data.fields.push(field);

    data.fields.push(new StringDataDefinition("officeLocationID"));
    data.fields.push(new StringDataDefinition("deskID"));

    data.value = {
        employeeID: "100",
        firstName: "Carl",
        lastName: "Hewitt",
        socialSecurityNumber: "000-000-0000",
        homeAddress: {
            streetAddress: "120 Tall Pine Ln",
            city: "abc...",
            state: "abc...",
            zipCode: "abc...",
            country: "abc...",
        },
        emailAddress: "abc...",
        phoneNumber: "abc...",
        dateOfBirth: "2000-02-16T11:11:00.000-05:00",
        dateOfHire: "2022-09-20T11:10:03.563-04:00",
        dateOfTermination: "2022-09-20T11:10:03.563-04:00",
        position: "CT)",
        salaryBand: "AC",
        department: "D",
        managerID: "9999",
        fullTime: true,
        benefitsID: "sd",
        exempt: true,
        disciplinaryActionsHistory: [
            {
                description: "abc...",
                currentManagerID: "abc...",
                actionTaken: "abc...",
                dateOfIncident: "2022-09-20T11:10:03.563-04:00",
            },
        ],
        vacationDaysUsed: 12,
        sickDaysUsed: 1,
        vacationDaysRemaining: 3,
        sickDaysRemaining: 4,
        emergencyContactName: "abc...",
        emergencyContactPhoneNumber: "757-555-5555",
        emergencyContactRelationship: "same",
        onboarded: true,
        promotionHistory: [
            {
                position: "abc...",
                dateOfPromotion: "2022-09-20T11:10:03.563-04:00",
                comments: "abc...",
                salary: 10003,
            },
        ],
        isManager: true,
        directReportsID: ["abc..."],
        officeLocationID: "abc...",
        deskID: "abc...",
    };

    return data;
};
